import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function ContactCta() {
  return (
    <section className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 rounded-lg border border-background-200 bg-background-50 p-6 md:grid-cols-2 md:p-12">
          <div>
            <span className="flex items-center gap-2 font-label text-xs tracking-[0.2em] text-primary-600">
              <i className="ri-mail-send-line" aria-hidden="true"></i>
              CONTACT
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              订阅更新，或者把线索交给我们
            </h2>
            <p className="mt-4 text-sm leading-loose text-foreground-700">
              留下邮箱可以收到新一期赛果解析。如果你手上有公示照片、通稿截图、赛程文件或票数变化记录，我们会先做交叉验证，确认可用后才会进入选题，并且不会公开你的身份信息。
            </p>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center">
              <Link
                to="/about#contact"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
              >
                <i className="ri-edit-2-line" aria-hidden="true"></i>
                前往订阅与投递
              </Link>
              <a
                href={`mailto:${siteInfo.email}`}
                className="inline-flex items-center justify-center gap-2 rounded-md border border-background-300 px-6 py-3 font-label text-sm text-foreground-800 transition-colors hover:bg-background-100 whitespace-nowrap"
              >
                <i className="ri-mail-line" aria-hidden="true"></i>
                {siteInfo.email}
              </a>
            </div>
          </div>

          <div className="rounded-lg bg-secondary-100 p-6 md:p-8">
            <h3 className="font-heading text-lg font-bold text-secondary-950">我们更希望收到什么</h3>
            <ul className="mt-5 space-y-4 text-sm leading-relaxed text-secondary-900">
              <li className="flex gap-3">
                <i className="ri-checkbox-circle-line mt-0.5 text-lg text-primary-600" aria-hidden="true"></i>
                带时间与来源的公示照片、赛程文件、通稿原文
              </li>
              <li className="flex gap-3">
                <i className="ri-checkbox-circle-line mt-0.5 text-lg text-primary-600" aria-hidden="true"></i>
                票数变化记录，尤其是深夜时段的增量截图
              </li>
              <li className="flex gap-3">
                <i className="ri-checkbox-circle-line mt-0.5 text-lg text-primary-600" aria-hidden="true"></i>
                合约中与保密期、违约金相关的条款原文
              </li>
              <li className="flex gap-3">
                <i className="ri-close-circle-line mt-0.5 text-lg text-accent-700" aria-hidden="true"></i>
                <span>仅有转述、没有物料支撑的内容，我们只能标注为待验证线索</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}